import { required } from "vuelidate/lib/validators";
import { Model } from "./Model";
import { Tipo, TipoNoValidation } from "./Tipo";

class RegimeEstadual extends Model {
  constructor() {
    super();
    this.vigencia = "";
    this.mva = 0;
    this.fundoPobreza = 0;
    this.cargaMedia = 0;
    this.tipo = new Tipo();
  }
}

const RegimeEstadualValidation = {
  vigencia: {
    required,
  },
  tipo: {
    descricao: { required },
  },
};

const RegimeEstadualNoValidation = {
  vigencia: {},
  tipo: TipoNoValidation,
};

export { RegimeEstadual, RegimeEstadualValidation, RegimeEstadualNoValidation };
